import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { HealthService } from '../cms/health/health.service';

@Injectable()
export class HealthResolver implements Resolve<any> {
  constructor(private healthService: HealthService) {}

  resolve() {
     return this.healthService.getHealthContent();
  }
}
